// src/app/features/peelhalton/peelhalton.module.ts
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../../shared/shared.module';

// PeelHalton components
import {PeelHaltonDashboardComponent} from '../shared/components/dashboard/peelhalton-dashboard.component';
import {PeelHaltonListingsSearchComponent} from '../shared/components/search-filter/peelhalton-listings-search.component';
import {PeelHaltonListingDetailsFullComponent} from '../shared/components/listing-details/peelhalton-listing-details-full.component';

// PeelHalton services
import {PeelHaltonListingsService} from '../shared/services/peelhalton-listings.service';
import {OakvilleRoutingModule} from "./oakville-routing.module";
import {LISTINGS_SERVICE_TOKEN} from "../../../core/services/listings-service.token";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    OakvilleRoutingModule,

    // Standalone components
    PeelHaltonDashboardComponent,
    PeelHaltonListingDetailsFullComponent,
    PeelHaltonListingsSearchComponent,
  ],
  providers: [
    PeelHaltonListingsService,
    {provide: LISTINGS_SERVICE_TOKEN, useClass: PeelHaltonListingsService}

  ]
})
export class OakvilleModule {
}
